import React, { useState } from "react";
import { marked } from "marked";
import "./App.css";

marked.setOptions({
  breaks: true,
  gfm: true,
});

const defaultMarkdown = `# Welcome to my React Markdown Previewer!
## Fun facts about cats.
This is a link to more facts [link](https://www.petmd.com/cat/general-health/fun-facts-about-cats)
Some inline code: \`const x = 5;\` between 2 backticks.
\`\`\`
// Code block
function hello() {
  console.log("Hello, world!");
}
\`\`\`
- 1. Only 20% of Orange Cats Are Female
- 2. Cats Have Fewer Taste Buds Than Dogs or People
- 3. Cats Don’t Get Cavities
> Blockquote
**Cats are so cute!**
![Image](./cat-img/cute.png)
`;

function App() {
  const [markdown, setMarkdown] = useState(defaultMarkdown);

  return (
    <div className="container">
      <h1>My Markdown Previewer</h1>

      <div className="editor-container">
        <h2>Editor</h2>
        <textarea
          id="editor"
          value={markdown}
          onChange={(e) => setMarkdown(e.target.value)}
          rows="10"
        />
      </div>

      <div className="preview-container">
        <h2>Preview</h2>
        <div
          id="preview"
          dangerouslySetInnerHTML={{ __html: marked(markdown) }}
        />
      </div>
    </div>
  );
}

export default App;
